(function () {
  const body = document.body;

  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function initHeader() {
    const header = qs('[data-site-header]');
    const toggle = qs('[data-menu-toggle]');
    const mobileMenu = qs('[data-mobile-menu]');
    const submenuToggle = qs('[data-mobile-submenu-toggle]');
    const submenu = qs('[data-mobile-submenu]');

    if (header) {
      const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 20);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (toggle && mobileMenu) {
      toggle.addEventListener('click', () => {
        const open = !mobileMenu.classList.contains('is-open');
        mobileMenu.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        body.classList.toggle('menu-open', open);
      });
    }

    if (submenuToggle && submenu) {
      submenuToggle.addEventListener('click', () => {
        const open = !submenu.classList.contains('is-open');
        submenu.classList.toggle('is-open', open);
        submenuToggle.setAttribute('aria-expanded', String(open));
      });
    }
  }

  function initBackToTop() {
    const button = qs('[data-back-to-top]');
    if (!button) return;

    const onScroll = () => {
      button.classList.toggle('is-visible', window.scrollY > 300);
    };

    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initSliders() {
    qsa('[data-slider]').forEach((slider) => {
      const slides = qsa('[data-slide]', slider);
      const dots = qsa('[data-slide-dot]', slider);
      const prev = qs('[data-slide-prev]', slider);
      const next = qs('[data-slide-next]', slider);
      const interval = Number(slider.dataset.interval || 5500);
      let index = 0;
      let timer = null;
      let touchStart = 0;

      if (slides.length <= 1) return;

      const setActive = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        const progress = qs('[data-slider-progress]', slider);
        if (progress) {
          progress.style.animation = 'none';
          progress.offsetHeight;
          progress.style.animation = '';
        }
      };

      const restart = () => {
        if (timer) clearInterval(timer);
        timer = setInterval(() => setActive(index + 1), interval);
      };

      prev && prev.addEventListener('click', () => { setActive(index - 1); restart(); });
      next && next.addEventListener('click', () => { setActive(index + 1); restart(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { setActive(i); restart(); }));

      slider.addEventListener('touchstart', (event) => {
        touchStart = event.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', (event) => {
        const diff = touchStart - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          setActive(diff > 0 ? index + 1 : index - 1);
          restart();
        }
      });

      setActive(0);
      restart();
    });
  }

  function initCarousels() {
    qsa('[data-carousel]').forEach((carousel) => {
      const track = qs('[data-carousel-track]', carousel);
      const items = qsa('[data-carousel-item]', carousel);
      const dotsWrap = qs('[data-carousel-dots]', carousel);
      const prev = qs('[data-carousel-prev]', carousel);
      const next = qs('[data-carousel-next]', carousel);
      let index = 0;

      if (!track || items.length === 0) return;

      const perView = () => {
        if (window.matchMedia('(max-width: 720px)').matches) return 1;
        if (window.matchMedia('(max-width: 1080px)').matches) return 2;
        return 3;
      };

      const maxIndex = () => Math.max(0, items.length - perView());

      const paintDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (let i = 0; i <= maxIndex(); i += 1) {
          const dot = document.createElement('button');
          dot.className = 'slider-dot' + (i === index ? ' is-active' : '');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => setIndex(i));
          dotsWrap.appendChild(dot);
        }
      };

      const setIndex = (nextIndex) => {
        index = Math.min(Math.max(nextIndex, 0), maxIndex());
        const itemWidth = items[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
        track.style.transform = `translateX(-${index * (itemWidth + gap)}px)`;
        qsa('button', dotsWrap || document.createElement('div')).forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      };

      prev && prev.addEventListener('click', () => setIndex(index <= 0 ? maxIndex() : index - 1));
      next && next.addEventListener('click', () => setIndex(index >= maxIndex() ? 0 : index + 1));
      window.addEventListener('resize', () => { paintDots(); setIndex(index); }, { passive: true });

      paintDots();
      setIndex(0);
    });
  }

  function initProductCards() {
    qsa('[data-product-card-form]').forEach((form) => {
      const card = form.closest('.product-card');
      const select = qs('[name="id"]', form);
      const price = qs('[data-card-price]', card || form);
      const buttons = qsa('[data-card-variant]', card || form);

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
          if (select) select.value = button.dataset.variantId;
          if (price && button.dataset.variantPrice) price.textContent = button.dataset.variantPrice;
        });
      });
    });
  }

  function shouldUseDefaultView(url) {
    return /^\/(collections|products|pages)(\/|$)/.test(url.pathname)
      && !url.searchParams.has('view');
  }

  function withDefaultView(href) {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
      return href;
    }

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return href;
    }

    if (url.origin !== window.location.origin || !shouldUseDefaultView(url)) {
      return href;
    }

    url.searchParams.set('view', 'serenity20260616');
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function initStorefrontViewLinks() {
    qsa('a[href]').forEach((link) => {
      const normalizedHref = withDefaultView(link.getAttribute('href'));
      if (normalizedHref !== link.getAttribute('href')) {
        link.setAttribute('href', normalizedHref);
      }
    });
  }

  function initProductForms() {
    qsa('[data-product-form]').forEach((form) => {
      const variants = JSON.parse(form.dataset.variants || '[]');
      const idInput = qs('[name="id"]', form);
      const price = qs('[data-product-price]');
      const addButton = qs('[data-add-button]', form);

      const findVariant = () => {
        const selected = qsa('[data-product-option]', form).map((group) => {
          const checked = qs('input:checked', group);
          return checked ? checked.value : null;
        });
        return variants.find((variant) => {
          return selected.every((value, i) => !value || variant.options[i] === value);
        });
      };

      const formatMoney = (cents) => {
        const amount = (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
        const format = window.moneyFormat || '${{amount}}';
        return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount.replace(/\..*/, '')).replace(/\{\{\s*amount\s*\}\}/, amount);
      };

      const shoppingCartIcon = () => '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>';

      const sync = () => {
        const variant = findVariant();
        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = window.themeStrings ? window.themeStrings.unavailable : 'Unavailable';
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (addButton) {
          addButton.disabled = !variant.available;
          if (variant.available) {
            addButton.innerHTML = shoppingCartIcon() + (window.themeStrings ? window.themeStrings.addToCart : 'ADD TO CART');
          } else {
            addButton.textContent = window.themeStrings ? window.themeStrings.soldOut : 'SOLD OUT';
          }
        }
      };

      qsa('input[type="radio"]', form).forEach((input) => input.addEventListener('change', sync));
      sync();
    });
  }

function initGallery() {
  qsa('[data-product-gallery]').forEach((gallery) => {
    const media = qsa('[data-gallery-media]', gallery);
    const thumbs = qsa('[data-gallery-thumb]', gallery);
    if (media.length <= 1) return;

    const setActive = (index) => {
      media.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        // Pause any videos that are no longer active
        const video = item.querySelector('video');
        if (video) {
          if (i === index) {
            video.play();
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setActive(index));
    });
  });
}
  document.addEventListener('DOMContentLoaded', () => {
    initStorefrontViewLinks();
    initHeader();
    initBackToTop();
    initSliders();
    initCarousels();
    initProductCards();
    initProductForms();
    initGallery();
  });
})();
